import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
  marginBottom: '20px',
});

const SuccessRedeemPage = () => {
  const navigate = useNavigate();
  return (
    <BackgroundContainer>
      <BaseFormContainer sx={{
        padding: { xs: 2, sm: 3 },
        boxSizing: 'border-box',
        marginBottom: '20px',
      }}>
        <BaseHeader sx={{
          fontSize: '3rem',
          '@media (max-width: 320px)': { fontSize: '2.8rem' },
          textAlign: 'center',
        }}>
          What A Gift!
        </BaseHeader>
        <Subtitle style={{
          color: 'rgba(237, 218, 241, 0.7)',
          marginBottom: '20px',
          textAlign: 'center',
          fontSize: '1.2rem',
        }}>
          You've got a paid membership for Free!
        </Subtitle>
        <Subtitle style={{
          color: 'rgba(237, 218, 241, 0.5)',
          marginBottom: '30px',
          textAlign: 'center',
          fontSize: '1rem',
        }}>
          Enjoy all the premium features — they're yours.
        </Subtitle>
        <BaseButton onClick={() => navigate('/')}>
          Let's Play!
        </BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  );
};

export default SuccessRedeemPage;
